import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import '@fortawesome/fontawesome-free/css/all.min.css';

import packageJson from '../package.json';

import App from './App';
import * as serviceWorker from './serviceWorker';

console.log(`Starting ${packageJson.name} version ${packageJson.version}`)
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
